import React from 'react';
import styled from "styled-components";
import { useState } from "react";
import {education} from "../components/Education";
import {experience} from "../components/Experience";
import ProgressBar from 'react-animated-progress-bar';
import {useNavigate} from "react-router-dom";

import {device} from "../components/Devices";

function Career() {

    const [active, setActive] = useState("education");
    const navigate = useNavigate();

    const codingDetails = () => {
        let path = "/contact";
        navigate(path);
    }

    const agileDetails = () => {
        let path = "/agile";
        navigate(path);
    }




    return (

        <Main_Career_Container>

            <h1>My Ca<span>reer</span></h1>

            <ul>
                <li
                    onClick={() => setActive("education")}
                    className={active === "education" ? "active" : ""}
                >
                    Education
                </li>
                <li
                    onClick={() => setActive("experience")}
                    className={active === "experience" ? "active" : ""}
                >
                    Experience
                </li>
                <li
                    onClick={() => setActive("skills")}
                    className={active === "skills" ? "active" : ""}
                >
                    Skills
                </li>
            </ul>

            <section>

                {active === "education" &&

                    <article>
                        <ul>
                            {education.map((e) => {
                                return (
                                    <li key={e.id}>
                                        <h3>{e.degree}</h3>
                                        <p>{e.Title}</p>
                                        <span>{e.year}</span>
                                    </li>
                                )
                            })}
                        </ul>
                    </article>
                }

                {active === "experience" &&

                    <article>
                        <ul>
                            {experience.map((e) => {
                                return (
                                    <li
                                        className="experience"
                                        key={e.id}>
                                        <h3>{e.org}</h3>
                                        <p>{e.period}</p>
                                        <span>{e.description}</span>
                                    </li>
                                )
                            })}
                        </ul>
                    </article>

                }

                {active === "skills" &&

                    <article className="skills_container">

                        <div onClick={agileDetails}>
                            <label>Professional Agile Coaching</label>
                            <aside>
                                <ProgressBar
                                    width="200px"
                                    height="12px"
                                    fontSize="18px"
                                    rect
                                    fontColor="#FBFBFB"
                                    percentage="79"
                                    rectPadding="1px"
                                    rectBorderRadius="5px"
                                    trackPathColor="transparent"
                                    bgColor="#EC7D0F"
                                    trackBorderColor="white"
                                />
                            </aside>
                        </div>

                        <div onClick={agileDetails}>
                            <label>Agile overall Knowledge</label>
                            <aside>
                                <ProgressBar
                                    width="200px"
                                    height="12px"
                                    fontSize="18px"
                                    rect
                                    fontColor="#FBFBFB"
                                    percentage="79"
                                    rectPadding="1px"
                                    rectBorderRadius="5px"
                                    trackPathColor="transparent"
                                    bgColor="#EC7D0F"
                                    trackBorderColor="white"
                                />
                            </aside>
                        </div>

                        <div onClick={agileDetails}>
                            <label>Scaling Agile</label>
                            <aside>
                                <ProgressBar
                                    width="200px"
                                    height="12px"
                                    fontSize="18px"
                                    rect
                                    fontColor="#FBFBFB"
                                    percentage="70"
                                    rectPadding="1px"
                                    rectBorderRadius="5px"
                                    trackPathColor="transparent"
                                    bgColor="#EC7D0F"
                                    trackBorderColor="white"
                                />
                            </aside>
                        </div>

                        <div onClick={agileDetails}>
                            <label>Obeya</label>
                            <aside>
                                <ProgressBar
                                    width="200px"
                                    height="12px"
                                    fontSize="18px"
                                    rect
                                    fontColor="#FBFBFB"
                                    percentage="60"
                                    rectPadding="1px"
                                    rectBorderRadius="5px"
                                    trackPathColor="transparent"
                                    bgColor="#EC7D0F"
                                    trackBorderColor="white"
                                />
                            </aside>
                        </div>

                        <div onClick={codingDetails}>
                            <label>JavaScript</label>
                            <aside>
                                <ProgressBar
                                    width="200px"
                                    height="12px"
                                    fontSize="18px"
                                    rect
                                    fontColor="#FBFBFB"
                                    percentage="40"
                                    rectPadding="1px"
                                    rectBorderRadius="5px"
                                    trackPathColor="transparent"
                                    bgColor="#EC7D0F"
                                    trackBorderColor="white"
                                />
                            </aside>
                        </div>

                        <div onClick={codingDetails}>
                            <label>HTML & CSS</label>
                            <aside>
                                <ProgressBar
                                    width="200px"
                                    height="12px"
                                    fontSize="18px"
                                    rect
                                    fontColor="#FBFBFB"
                                    percentage="50"
                                    rectPadding="1px"
                                    rectBorderRadius="5px"
                                    trackPathColor="transparent"
                                    bgColor="#EC7D0F"
                                    trackBorderColor="white"
                                />
                            </aside>
                        </div>

                        <div onClick={codingDetails}>
                            <label>React</label>
                            <aside>
                                <ProgressBar
                                    width="200px"
                                    height="12px"
                                    fontSize="18px"
                                    rect
                                    fontColor="#FBFBFB"
                                    percentage="55"
                                    rectPadding="1px"
                                    rectBorderRadius="5px"
                                    trackPathColor="transparent"
                                    bgColor="#EC7D0F"
                                    trackBorderColor="white"
                                />
                            </aside>
                        </div>

                        <div onClick={codingDetails}>
                            <label>Java</label>
                            <aside>
                                <ProgressBar
                                    width="200px"
                                    height="12px"
                                    fontSize="18px"
                                    rect
                                    fontColor="#FBFBFB"
                                    percentage="20"
                                    rectPadding="1px"
                                    rectBorderRadius="5px"
                                    trackPathColor="transparent"
                                    bgColor="#EC7D0F"
                                    trackBorderColor="white"
                                />
                            </aside>
                        </div>

                    </article>

                }


            </section>


        </Main_Career_Container>

    );
}

export default Career;

const Main_Career_Container = styled.div`

  width: 100%;
  min-width: 320px;
  max-width: 320px;
  height: auto;
  background-color: transparent;
  //margin: 10px;
  margin-top: 120px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //border: 1px solid black;

  @media ${device.mobileL} {
    max-width: 425px;
  }

  @media ${device.tablet} {
    width: 768px;
    max-width: 768px;
  }

  @media ${device.laptop} {
    width: 1024px;
    max-width: 1024px;
  }

  @media ${device.laptopL} {
    width: 1400px;
    max-width: 1440px;
  }
  
  
  
  
  h1 {
    font-size: 35px;
    font-weight: lighter;
    color: var(--mainTextColor);
    margin-bottom: 30px;
    
    @media ${device.tablet} {
      margin-top: 50px;
    }

    @media ${device.laptopL} {
      margin-top: 100px;
      font-size: 50px;
    }

    span {
      border-bottom: 2px solid var(--orange);
    }
  }

  ul {
    display: flex;
    flex-direction: row;
    justify-content: space-between;


    text-decoration: none;
    list-style: none;
    width: 320px;
    margin-bottom: 20px;

    @media ${device.mobileL} {
      width: 380px;
    }

    @media ${device.tablet} {
      width: 600px;
    }

    @media ${device.laptopL} {
      width: 860px;
    }

    li {
      //border: 1px solid var(--orange);
      border-radius: 5px;
      padding: 6px;
      padding-top: 8px;
      width: 100px;
      height: 30px;
      text-align: center;
      color: var(--mainBackGroundColor);
      background-color: var(--blackShadow);
      cursor: pointer;

      @media ${device.mobileL} {
        width: 120px;
      }

      @media ${device.tablet} {
        width: 150px;
      }

      @media ${device.laptopL} {
        width: 200px;
        height: 40px;
        font-size: 30px;
        font-weight: lighter;
      }

      &:hover {
        background-color: var(--orange);
        color: var(--mainTextColor);
      }

      &.active {
        background-color: var(--orange);
        color: var(--mainTextColor);
      }
      

    }

  }

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    //border: 1px solid black;
    width: 100%;
    max-width: 320px;
    min-width: 320px;
    height: 954px;

    overflow-x: hidden;
    overflow-y: scroll;


    @media ${device.mobileL} {
      max-width: 425px;
    }

    @media ${device.tablet} {
      max-width: 768px;
    }

    @media ${device.laptopL} {
      max-width: 1440px;
    }

    article {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;

      width: 100%;
      height: 100%;
      max-height: auto;
      //border: 1px solid black;
      margin-bottom: 10px;
      background-color: transparent;
      
      @media ${device.laptopL} {
        margin-left: 60px;
      }

      ul {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        li {
          background-color: transparent;
          width: 320px;
          height: auto;
          min-height: 80px;
          max-height: 100%;
          font-weight: lighter;
          text-align: left;
          margin-top: 15px;
          //border: 1px solid black;

          @media ${device.mobileL} {
            width: 380px;
          }

          @media ${device.tablet} {
            width: 600px;
            font-size: 40px;
          }

          @media ${device.laptopL} {
            width: 800px;
            font-size: 40px;
          }

          
        }
        .experience {

      }

    }

    

      h2 {
        color: var(--mainTextColor);
      }

      h3 {
        color: var(--mainTextColor);
        font-weight: lighter;
        font-size: 20px;
        //margin-bottom: 5px;
        //margin-top: 5px;

        @media ${device.tablet} {
          font-size: 30px;
        }

        @media ${device.laptopL} {
          font-size: 45px;
          
        }
        
        


      }

      p {
        color: var(--dimGrey);
        font-size: 20px;
        margin-bottom: 10px;
        margin-top: 10px;
        
        @media ${device.tablet} {
          font-size: 25px;
        }

        @media ${device.laptopL} {
          font-size: 30px;

        }

      }

      span {
        color: var(--dimGrey);
        font-size: 18px;
        //margin-bottom: 10px;
      }

    }

    .skills_container {

      display: flex;
      flex-direction: column;
      align-items: center;

      height: 600px;
      max-height: 600px;
      min-height: 600px;
      width: 300px;
      max-width: 300px;
      margin-right: 55px;
      margin-top: 20px;

      div {

        width: 250px;
        cursor: pointer;
        //border: 1px solid black;

        @media ${device.mobileL} {
          width: 300px;
        }

        @media ${device.tablet} {
          width: 440px;
        }

        @media ${device.laptopL} {
          width: 600px;
          font-size: 25px;
          

        }
        

        label {
          color: var(--mainTextColor);
          font-weight: lighter;
        }

      }


    }

  }

`;